import { create } from 'zustand';

type DrawerStore = {
  taskId: string;
  isDrawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  setTaskId: (id: string) => void;
};

export const useDrawerStore = create<DrawerStore>(set => ({
  isDrawerOpen: false,
  taskId: '',
  setDrawerOpen: open => set({ isDrawerOpen: open }),
  setTaskId: id => set({ taskId: id }),
}));
